export default __webpack_public_path__ + "static/materiel-a840fe1ad1e4f9934e5457051c83a4aa.jpg";